import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Company'],
});

export const companyApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllCompanies: builder.query({
      query: (payload) => {
        let url = `location_masters/`;
        let params = {};
        if (payload) {
          Object.keys(payload).forEach((key) => {
            if (payload[key] !== null) {
              params[key] = payload[key];
            }
          });
        }
        return { url, params: params };
      },
      providesTags: ['Company'],
    }),
    findCompanyById: builder.query({
      query: (id) => `location_masters/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Company', id: result.id }] : ['Company'];
      },
    }),
    createCompany: builder.mutation({
      query: (Company) => ({
        url: `location_masters/`,
        method: 'POST',
        body: Company,
      }),
      invalidatesTags: ['Company'],
    }),
    updateCompany: builder.mutation({
      query: (Company) => ({
        url: `location_masters/${Company.id}/`,
        method: 'PATCH',
        body: Company,
      }),
      invalidatesTags: ['Company'],
    }),
    deleteCompany: builder.mutation({
      query: (Company) => ({
        url: `location_masters/${Company.id}/`,
        method: 'PATCH',
        body: Company,
      }),
      invalidatesTags: ['Company'],
    }),
    destroyCompany: builder.mutation({
      query: (Company) => ({
        url: `location_masters/${Company.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Company'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllCompaniesQuery,
  useFindCompanyByIdQuery,
  useCreateCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useDestroyCompanyMutation,
} = companyApi;
